module.exports = __webpack_public_path__ + "img/easyer.224c57f2.png";